import { BarcodeTypeOption } from '@/utils/constants';
import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import { validatorConditionalRequired, validatorRequire, validatorRequireNumber } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    name: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    barcodeTypeOption: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'common.barcodeType',
        required: true,
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('barcodeTypes')
      },
      rules: [{ validator: validatorRequireNumber }]
    },
    barcodePrefix: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'common.barcodePrefix',
        maxlength: 3,
        required: true
      },
      dynamicRules: form => [
        { validator: validatorConditionalRequired(form.barcodeTypeOption !== BarcodeTypeOption.None) }
      ],
      dynamicProps: form => ({
        visible: form.barcodeTypeOption !== BarcodeTypeOption.None
      })
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return {
    ...item
  };
}
